/** @jsxImportSource @emotion/react */
import { jsx, css, keyframes } from "@emotion/react";
import {
  BottomNavigation,
  BottomNavigationAction,
  Paper,
  Button,
  Grid,
} from "@mui/material";
import { useHistory, Link } from "react-router-dom";
import { useState } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
// import Home from '../assets/img/home.svg'
import { ReactComponent as Home } from "../assets/home.svg";
import { ReactComponent as Buy } from "../assets/buy.svg";
import { ReactComponent as Book } from "../assets/book.svg";
import { ReactComponent as Profile } from "../assets/profile.svg";
import { ReactComponent as More } from "../assets/more.svg";

const theme = createTheme({
  components: {
    MuiButtomNavigationAction: {
      styleOverrides: {
        root: {
          display: "flex",
          direction: "column",
          alignItems: "center",
          jusifyContent: "space-around",
          "&&.Mui-selected": {
            fontSize: "13px",
          },
        },
      },
    },
  },
});

function BottomMenu(props) {
  const history = useHistory();

  const active = props.active;

  const [value, setValue] = useState(active);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Grid
      sx={{
        zIndex: 100,
      }}
    >
      <Paper
        style={{
          width: "100%",
          position: "fixed",
          bottom: 0,
          // borderTop: "solid gray 1px",
          background: "transparent",
        }}
      >
        <ThemeProvider theme={theme}>
          <BottomNavigation
            sx={{
              background: "black",
              borderRadius: "15px 15px 0 0",
              height: "70px",
              "&& .Mui-selected": {
                fontSize: "13px",
              },
            }}
            showLabels
            value={value}
            onChange={handleChange}
          >
            <BottomNavigationAction
              component={Link}
              label="홈"
              value="home"
              to="/home"
              // value="Home"
              icon={<Home fill="currentColor" height="25px" />}
              sx={{
                minWidth: "20%",
                color: "white",
                "&.Mui-selected": { color: "#25b7d3", fill: "#25b7d3" },
              }}
              // onClick={() => {history.push('/home')}}
            />

            <BottomNavigationAction
              component={Link}
              label="쿠폰구매"
              value="buy"
              to="/buy"
              // value="Buy"
              icon={
                <Buy
                  fill="currentColor"
                  height="18px"
                  style={{ margin: "3.5px 0" }}
                />
              }
              sx={{
                color: "#606060",
                minWidth: "20%",
                alignItems: "center",
                color: "white",
                "&.Mui-selected": { color: "#25b7d3", fill: "#25b7d3" },
              }}
              // onClick={() => {history.push('/buy')}}
            />
            <BottomNavigationAction
              component={Link}
              label="수업예약"
              value="book"
              to="/book"
              // value="Book"
              icon={
                <Book
                  fill="currentColor"
                  height="25px"
                  style={{ margin: "1px 0" }}
                />
              }
              sx={{
                color: "#606060",
                minWidth: "20%",
                color: "white",
                "&.Mui-selected": { color: "#25b7d3", fill: "#25b7d3" },
              }}
              // onClick={() => {history.push('/book')}}
            />
            <BottomNavigationAction
              component={Link}
              label="내수업"
              value="mypage"
              to="/mypage?tab=1"
              // value="Profile"
              icon={
                <Profile
                  fill="currentColor"
                  height="25px"
                  style={{ margin: "1px 0" }}
                />
              }
              sx={{
                minWidth: "20%",
                color: "white",
                "&.Mui-selected": { color: "#25b7d3" },
              }}
              // onClick={() => {history.push('/profile')}}
            />
            <BottomNavigationAction
              component={Link}
              label="더보기"
              value="more"
              to="/more"
              // value="More"
              icon={
                <More
                  fill="currentColor"
                  width="18px"
                  style={{ margin: "11px 0" }}
                />
              }
              sx={{
                minWidth: "20%",
                color: "white",
                "&.Mui-selected": { color: "#25b7d3" },
              }}
              // onClick={() => {history.push('/more')}}
            />
          </BottomNavigation>
        </ThemeProvider>
      </Paper>
    </Grid>
  );
}

export default BottomMenu;
